<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>PMS Connector Details</v-card-title>
          <v-simple-table v-if="status">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">Value</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Username</td>
                  <td>{{ pmsConnDetails.usr }}</td>
                </tr>
                <tr>
                  <td>PMS Type</td>
                  <td>{{ pmsConnDetails.pmsType }}</td>
                </tr>
                <tr>
                  <td>Brand</td>
                  <td>{{ pmsConnDetails.brand }}</td>
                </tr>
                <tr>
                  <td>Provisioned:</td>
                  <td v-if="!pmsConnDetails.heartbeatRcvd">n/a</td>
                  <td v-else>{{ new Date(pmsConnDetails.ctdTs) }}</td>
                </tr>

                <tr>
                  <td>Linked Accounts:</td>
                  <td>{{ pmsConnDetails.linkedAccountCount }}</td>
                </tr>
                <tr>
                  <td>Last Heartbeat Received</td>
                  <td v-if="!pmsConnDetails.heartbeatRcvd">n/a</td>
                  <td v-else>{{ new Date(pmsConnDetails.heartbeatRcvd) }}</td>
                </tr>
                <tr>
                  <td>Last PMS Status</td>
                  <td>{{ pmsConnDetails.pmsStatus | pmsStatus }}</td>
                </tr>
                <tr>
                  <td>Last PMS Version Repoted</td>
                  <td>{{ pmsConnDetails.pmsVersion | versionFilter }}</td>
                </tr>
                <tr>
                  <td>Last Availability Data Received</td>
                  <td v-if="!pmsConnDetails.availabilityLastRcvdTs">n/a</td>
                  <td v-else>
                    {{ new Date(pmsConnDetails.availabilityLastRcvdTs) }}
                  </td>
                </tr>
                <tr>
                  <td>Last Availability Data Processed</td>
                  <td v-if="!pmsConnDetails.availabilityLastProcTs">n/a</td>
                  <td v-else>
                    {{ new Date(pmsConnDetails.availabilityLastProcTs) }}
                  </td>
                </tr>
                <tr>
                  <td>Last Availability Data Input File</td>
                  <td>{{ pmsConnDetails.availabilityLastInS3Key }}</td>
                </tr>
                <tr>
                  <td>Last Availability Data Output File</td>
                  <td>{{ pmsConnDetails.availabilityLastOutS3Key }}</td>
                </tr>
                <tr>
                  <td>Sub / Notification Channel</td>
                  <td>{{ pmsConnDetails.sub }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    pmsConnDetails: Object,
  },
  filters: {
    versionFilter: function (value) {
      try {
        const json = JSON.parse(decodeURIComponent(value));

        if (!json || typeof json !== "object") {
          return value;
        }
        const out = [];
        for (var key in json) {
          out.push(`${key}: ${json[key]}`);
        }
        return out.join(", ");
      } catch (err) {
        return value;
      }
    },
    pmsStatus: function(value) {
      switch (value) {
        case "OK":
          return "Connected";
          break;
        case "NotImplemented":
          return "n/a"
          break;
        default:
          return value;
      }
    }
  },
  data: function () {
    return {
      sub: "",
      loading: false,
      status: {},
    };
  },
};
</script>